<template>
  <div>
    <h2>
      <el-button class="pull-right"
                 v-if="canAdd()"
                 @click="showDialog()"
                 type="primary">Nuevo</el-button>
      Puestos de Trabajo
    </h2>
    <app-table
      @change-pagination="onChangePagination"
      @change-search="onChangeSearch"
      :total="total">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="name"
          label="Puesto">
        </el-table-column>
        <el-table-column
          prop="min_wage"
          label="Salario Mínimo">
        </el-table-column>
        <el-table-column
          width="100">
          <template slot-scope="scope">
            <el-button
              v-if="canUpdate()"
              size="mini"
              type="warning"
              @click="showDialog(scope.row)">
              <i class="el-icon-edit"></i>
            </el-button>
            <el-button
              v-if="!canUpdate() && canShow()"
              size="mini"
              type="primary"
              @click="showDialog(scope.row)">
              <i class="fa fa-eye"></i>
            </el-button>
            <el-button
              v-if="canDelete()"
              type="danger"
              size="mini"
              @click="handleDelete(scope.$index, scope.row)">
              <i class="el-icon-delete"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </app-table>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Puesto" prop="name">
              <el-input v-model="form.name" :disabled="canEditToSave()" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Salario Mínimo" prop="min_wage">
              <el-input type="number" :min="0" :disabled="canEditToSave()" v-model="form.min_wage"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Descripción" prop="description">
          <el-input type="textarea" v-model="form.description" :disabled="canEditToSave()" ></el-input>
        </el-form-item>
      </el-form>
      <div role="alert" v-if="error.message" class="el-alert el-alert--error">
        <div class="el-alert__content">
          <span class="el-alert__title is-bold">{{ error.message }}</span>
          <p class="el-alert__description">
            <ul>
              <li v-for="item in error.errors">{{ item[0] }}</li>
            </ul>
          </p>
        </div>
      </div>
      <el-alert
        v-if="success"
        title="Se ha guardado exitosamente."
        type="success">
      </el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancelar</el-button>
        <el-button type="primary"
                   v-if="!canEditToSave()"
                   :loading="processing"
                   @click="save()">Guardar</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import AppTable from '../../components/Table'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import {baseApi} from '../../configs/urls'

  export default {
    name: 'position-list',
    extends: BaseCrud,
    components: {
      AppTable
    },
    data () {
      const validateMin = (rule, value, callback) => {
        if (Number(value) <= 0) {
          callback(new Error('El salario minimo debe ser mayor a cero.'))
        } else {
          callback()
        }
      }
      return {
        baseUrl: baseApi + '/positions',
        basePermission: 'positions',
        form: {
          name: '',
          description: '',
          min_wage: 0
        },
        rules: {
          name: [
            { required: true, message: 'El nombre del puesto es requerido', trigger: 'blur' }
          ],
          description: [
            { required: true, message: 'La descripción es requerida', trigger: 'blur' }
          ],
          min_wage: [
            { required: true, message: 'El salario minimo es requerido', trigger: 'blur' },
            { validator: validateMin, trigger: 'blur,change' }
          ]
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/positions/PositionList.vue